import { recogniseLink } from 'utilities'

export interface RichTextProps {
  content: string
  className?: string
  highlightClassName?: string
  boldClassName?: string
}

const RichText = ({
  content,
  className,
  highlightClassName,
  boldClassName,
}: RichTextProps) => {
  const paragraphs = content.split('\n')

  const renderInlineLink = (text: string, keyPrefix: string) => {
    const { linkText, linkUrl, parts } = recogniseLink(text)
    if (!linkText || !linkUrl) return text

    return (
      <>
        {parts[0]}
        <a
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`${highlightClassName || 'text-green-800'} underline`}
          key={`${keyPrefix}-link`}
        >
          {linkText}
        </a>
        {parts[3]}
      </>
    )
  }

  const renderFormattedText = (text: string) => {
    const boldTextRegex = /\*\*(.*?)\*\*/g
    const parts = text.split(boldTextRegex)
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <strong key={index} className={boldClassName}>
            {part}
          </strong>
        )
      }

      return <span key={index}>{renderInlineLink(part, `${index}`)}</span>
    })
  }

  return (
    <div>
      {paragraphs.map((paragraph, index) => (
        <p className={className} key={index}>
          {renderFormattedText(paragraph)}
        </p>
      ))}
    </div>
  )
}

export default RichText
